import { RootState } from "../Store";
import { DeliveryCompany } from "../../entity/DeliveryCompany";
import { StoreDeliveryConfigurations } from "../../entity/StoreDeliveryConfiguration";

export const selectDeliveryCompanies: (
  state: RootState,
) => DeliveryCompany | null = (state: RootState) =>
  state.delivery.deliveryCompanies;

export const selectStoreConfig: (
  state: RootState,
) => StoreDeliveryConfigurations[] | undefined = (state: RootState) =>
  state.storeConfig.storeConfig;

export const selectListDeliveryCompanies: (
  state: RootState,
) => DeliveryCompany[] | null = (state: RootState) =>
  state.delivery.listDeliveryCompanies;
